import { render, staticRenderFns } from "./AutoTopUp.vue?vue&type=template&id=387a6140&scoped=true"
import script from "./AutoTopUp.vue?vue&type=script&lang=js"
export * from "./AutoTopUp.vue?vue&type=script&lang=js"
import style0 from "./AutoTopUp.vue?vue&type=style&index=0&id=387a6140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387a6140",
  null
  
)

export default component.exports